import { createAjv } from './create-ajv';
import { customFormats } from './formats';
import { customKeywords } from './keywords';
import { buildEnforceUriProtocolsKeyword } from './keywords/enforce-uri-protocols/enforce-uri-protocols';
import { buildValidRichTextKeyword } from './keywords/valid-rich-text/valid-rich-text';

/**
 * AJV recommends using a single instance shared across the entire application and its modules
 * read more: https://ajv.js.org/guide/managing-schemas.html#managing-schemas
 *
 * The instance exported here has been pre-wrapped in two ajv extension modules,
 *   1. avj-errors - adds an errorMessage keyword
 *   2. avj-formats - adds several new formats
 *
 * more details on the above are available in the `createAjv` documentation.
 *
 * It also contains custom formats and keywords created for the Config App
 */

// remove with https://everlong.atlassian.net/browse/CACT-2741
export const TEMP_PROTOCOLS = [
  'https',
  'ftps',
  'xmpp',
  'tel',
  'mailto',
  'callto',
  'sms',
  'manulifemobile',
];

export const ajv = createAjv({
  formats: customFormats,
  keywords: [
    ...customKeywords,
    // remove with https://everlong.atlassian.net/browse/CACT-2741
    buildValidRichTextKeyword(TEMP_PROTOCOLS),
    buildEnforceUriProtocolsKeyword(TEMP_PROTOCOLS),
  ],
});

// Consumers preferring customizable ajv configuration
export const createConfigurableAjv = (allowedUriProtocols?: string[]) => {
  const keywords = [...customKeywords];

  if (allowedUriProtocols) {
    keywords.push(buildValidRichTextKeyword(allowedUriProtocols));
    keywords.push(buildEnforceUriProtocolsKeyword(allowedUriProtocols));
  }

  return createAjv({
    formats: customFormats,
    keywords,
  });
};
